// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationId } from './HarvestOperation';
import { attributeChangeSource } from './AttributeChangeSource';
import { operatorId } from './Operator';
import { harvestOperationTemplateRevisionId } from './HarvestOperationTemplateRevision';
import { z } from 'zod';
export const harvestAttributeChangeGroupId = (z.string());
export const harvestAttributeChangeGroup = z.object({
    id: harvestAttributeChangeGroupId,
    harvest_operation_id: harvestOperationId,
    source: attributeChangeSource,
    operator_id: operatorId.nullable(),
    label: z.string().nullable(),
    template_revision_id: harvestOperationTemplateRevisionId,
    from_revision_id: harvestOperationTemplateRevisionId.nullable(),
    source_ref: z.string().nullable(),
    opened_at: z.date(),
    closed_at: z.date().nullable(),
});
export const harvestAttributeChangeGroupInitializer = z.object({
    id: harvestAttributeChangeGroupId.optional(),
    harvest_operation_id: harvestOperationId,
    source: attributeChangeSource,
    operator_id: operatorId.optional().nullable(),
    label: z.string().optional().nullable(),
    template_revision_id: harvestOperationTemplateRevisionId,
    from_revision_id: harvestOperationTemplateRevisionId.optional().nullable(),
    source_ref: z.string().optional().nullable(),
    opened_at: z.date().optional(),
    closed_at: z.date().optional().nullable(),
});
export const harvestAttributeChangeGroupMutator = z.object({
    id: harvestAttributeChangeGroupId.optional(),
    harvest_operation_id: harvestOperationId.optional(),
    source: attributeChangeSource.optional(),
    operator_id: operatorId.optional().nullable(),
    label: z.string().optional().nullable(),
    template_revision_id: harvestOperationTemplateRevisionId.optional(),
    from_revision_id: harvestOperationTemplateRevisionId.optional().nullable(),
    source_ref: z.string().optional().nullable(),
    opened_at: z.date().optional(),
    closed_at: z.date().optional().nullable(),
});
//# sourceMappingURL=HarvestAttributeChangeGroup.js.map